export const CropInformationDefaultDataSetDisease = {
  langMap: [
    {
      langCode: "en",
      name: "",
      summary: "",
      diseaseResistantCultivarAdvice: "",
      interCroppingSuggestionSummary: "",
      tips: "",
      transmission: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      prevention: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      treatment: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
      symptomProgression: [
        {
          displayOrder: 1,
          imageId: "",
          text: "",
          agriItemType: "GENERAL",
          plantId: "",
        },
      ],
    },
  ],
};

export const newDiseaseLangTemplate = {
  name: "",
  summary: "",
  diseaseResistantCultivarAdvice: "",
  interCroppingSuggestionSummary: "",
  tips: "",
  transmission: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  prevention: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  treatment: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
  symptomProgression: [
    {
      displayOrder: 1,
      imageId: "",
      text: "",
      agriItemType: "GENERAL",
      plantId: "",
    },
  ],
};
